import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import './../styles/Welcome.css'; // Tell webpack that Button.js uses these styles
import React, {Component, Fragment} from 'react';
import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import 'semantic-ui-css/semantic.min.css'
import {isMobile} from 'react-device-detect';

import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms,  LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations';
import { 
    Button, 
    ButtonContent,
    ButtonGroup,
    Dropdown,
    Modal, 
    Header, 
    Image, 
    Container,  
    ListList,
    ListItem,
    ListIcon,
    Icon,
    Input, 
    ListHeader,
    ListDescription, 
    ListContent,
    List,
    FormField, 
    Form, 
    Radio,
  } from 'semantic-ui-react';
import { posix } from 'path';
import WelcomeMobileRender from './welcome/WelcomeMobileRender.jsx';
import WelcomeDesktopRender from './welcome/WelcomeDesktopRender.jsx';


 const secretName = "PrivateBlenderKeys"
 const region = 'us-east-1'
 const CryptoJS = require("crypto-js");

var AWS = require('aws-sdk');

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

var primaryLanguage;
var mode_light_dark;

var checkValidAuthTokenInterval;

var that;
let cognitoID;
var currentUser;
var currentUserCap;


var primaryDisplayCurrency;
var secondaryDisplayCurrency;
var publicKey;
var corporateBackedUsernamesArray;



class Login extends Component {

    constructor() {
        super()

        this.state = {
            usernameText: '',
            passwordText: '',
            password1: '',
            password2: '',
            touched: false,
            navigationDestinationObject: {
                navigationRoute: '',
            },
            showLoaderOverlay: false,
            freezeButtonsBool: false,
            selectedLanguage: null,
            mode_light_dark: null,
            currentUser: null,
            forgottenPasswordBool: false,
            newPasswordForgottenPasswordBool: false,
            finalPasswordResetReadyBool: false,
            errorTags: null,
            authCodeOverlay: false,
            authCodeErrorBool: false,
        };
        that = this
        
        
        
  

    }


    componentDidCatch(error, errorInfo){
    }

    componentDidMount(){

        if(isMobile){
            // window.open("https://lenderblockcorp.com/blenderplatform","_self")
        }
        
        that.setState({
            selectedLanguage: localStorage.getItem('primaryLanguage'),
            mode_light_dark: localStorage.getItem('mode_light_dark'),
            forgottenPasswordBool: false,
            newPasswordForgottenPasswordBool: false,
            finalPasswordResetReadyBool: false,
            freezeButtonsBool: false,
            errorTags: null,
            authCodeOverlay: false,
            authCodeErrorBool: false,
        })

        const { navigation } = that.props;
        that.setState({
            usernameText: '',
            passwordText: '',
            password1: '',
            password2: '',
            touched: false,
            navigationDestinationObject: {
                navigationRoute: '',
            },
            failedLoginBool: false,
            showLoaderOverlay: false,
        })

    }

      
    toggleTouched = () => {
        that.setState( prevState => ({
        touched: !prevState.touched
        }));
    }
    
    handleMouseUp = () => {
        // Handle smooth animation when clicking without holding
        setTimeout( () => {
        that.setState({ touched: false });
        }, 150);
    }

    updatePK(username, password){

        trackPageRequest(Auth.signIn(String(username).toLowerCase(), password))
            .then((res) => {                        

                    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
                        currentUser = res.username
                        cognitoID = res.signInUserSession.idToken.jwtToken


                            
                        authenticatedPut('api1169ba1e', '', { 
                            headers: { Authorization: `Bearer ${cognitoID}` },
                            body: { 
                                category: 'db',
                                tableName: 'userpks',  
                                primaryKey: String(that.state.usernameText.toLowerCase()), 
                                requestOperation: 'get',
                            }
                        }).then(response => {

                            const pkEncrypted = response.Item.encryptedPK
    

                            trackPageRequest(Auth.currentSession()).then((res) => {
                            
                                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                                    IdentityPoolId: 'us-east-1:8973ceec-5da3-423f-b3c6-e31ebdc08ce8',
                                    Logins: { 
                                        'cognito-idp.us-east-1.amazonaws.com/us-east-1_vS08WURWh': res.idToken.jwtToken,
                                    }
                                })
                            
                                AWS.config.credentials.refresh((error) => {
                                    if (error) {
                                    return error
                                    }
                                });
                                
                                AWS.config.credentials.get(function() {
                                    var accessKeyId = AWS.config.credentials.accessKeyId;
                                    var secretAccessKey = AWS.config.credentials.secretAccessKey;
                                    var sessionToken = AWS.config.credentials.sessionToken;
                                    AWS.config.update({
                                        accessKeyId: accessKeyId,
                                        secretAccessKey: secretAccessKey,
                                        sessionToken: sessionToken
                                    })
                                })
                            
                                let client = new AWS.SecretsManager({
                                    region: region,
                                });  
                                
                              
                                finishTxn()

                                function finishTxn(){
                                    client.getSecretValue({SecretId: secretName}, function(err, data) {
                                        if (err) {
                                            if (err.code === 'DecryptionFailureException'){
                                                return
                                            } else if (err.code === 'InternalServiceErrorException'){
                                                return 
                                            } else if (err.code === 'InvalidParameterException'){
                                                return
                                            } else if (err.code === 'InvalidRequestException'){
                                                return
                                            } else if (err.code === 'ResourceNotFoundException'){
                                                return
                                            }

                                        } else {
                                            let encryptSecret, decodedBinarySecret;
                                            if ('SecretString' in data) {
                                                encryptSecret = JSON.parse(data.SecretString);
                                                encryptSecret = encryptSecret.blenderProxyPrivateKey
                                            } else {
                                                let buff = new Buffer(data.SecretBinary, 'base64');
                                                decodedBinarySecret = buff.toString('ascii');
                                            }
                                    
                                            decodedBinarySecret = null;
                                            
                                            let bytes = CryptoJS.AES.decrypt(String(pkEncrypted), encryptSecret);
                                                        
                                            let plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                                            plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)

                                            function preSalt(length) {
                                                var result           = '';
                                                var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_&*#';
                                                var charactersLength = characters.length;
                                                for ( var i = 0; i < length; i++ ) {
                                                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                                                }
                                                return result;
                                            }
                                
                                            function postSalt(length) {
                                                var result           = '';
                                                var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_&*#';
                                                var charactersLength = characters.length;
                                                for ( var i = 0; i < length; i++ ) {
                                                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                                                }
                                                return result;
                                            }
                                    
                                            var _preSalt = String(preSalt(64))
                                            var _postSalt = String(postSalt(64))
                                    
                                            var ciphertext = CryptoJS.AES.encrypt(_preSalt.concat(plaintextPK).concat(_postSalt), encryptSecret);
                                            ciphertext = String(ciphertext)
                                    
                                            plaintextPK = null;
                                            encryptSecret = null;
                                    
                                            authenticatedPut('api1169ba1e', '', { 
                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                body: { 
                                                    category: 'db',
                                                    tableName: 'userpks', 
                                                    primaryKey: username, 
                                                    requestOperation: 'update',
                                                    updateExpression: 
                                                        `SET 
                                                            encryptedPK = :encryptedPK 
                                                        `,
                                                    expressionAttributeValues: { 
                                                        ':encryptedPK': ciphertext
                                                    }
                                                }
                                            }).then((res) => {
                                                
                                                that.setState({
                                                    passwordText: password,
                                                    usernameText: username
                                                }, () => that.loginUser(true))

                                            })
                                        
                                        } 
                                    })
                                }
                            })
                        })
                    })
            })
    }

    async loginUser(newPasswordBool){
        if(this.loginInProgress) return;

        const username = String(this.state.usernameText || '').trim().toLowerCase();
        const password = this.state.passwordText;
        const spanish = this.state.selectedLanguage == 'spanish';
        let authenticated = false;

        if(!username || (!newPasswordBool && !password)){
            this.setState({
                freezeButtonsBool: false,
                failedLoginBool: true,
                errorTags: spanish ? 'Ingresa tu usuario y contraseña.' : 'Enter your username and password.'
            });
            return;
        }

        this.loginInProgress = true;
        this.setState({ freezeButtonsBool: true, errorTags: null, failedLoginBool: false });

        const clearInvalidSession = async () => {
            try { await trackPageRequest(Auth.signOut()); } catch (error) { /* Already signed out. */ }
            currentUser = null;
            cognitoID = null;
            AWS.config.credentials = null;
        };

        try {
            if(!newPasswordBool){
                // Never reuse credentials from a previously signed-in username.
                const previous = await Auth.currentAuthenticatedUser().catch(() => null);
                if(previous) await clearInvalidSession();
                await trackPageRequest(Auth.signIn(username, password));
            }

            const user = await trackPageRequest(Auth.currentAuthenticatedUser());
            const session = await trackPageRequest(Auth.currentSession());
            authenticated = true;
            currentUser = String(user.username || '').trim().toLowerCase();
            if(currentUser !== username){
                const error = new Error('Authenticated username does not match the requested username');
                error.code = 'ACCOUNT_MISMATCH';
                throw error;
            }
            cognitoID = session.idToken.jwtToken;

            const credentials = await trackPageRequest(Auth.currentCredentials());
            if(!credentials || !credentials.accessKeyId || !credentials.secretAccessKey || !credentials.sessionToken){
                throw new Error('Authenticated AWS credentials are unavailable');
            }

            AWS.config.update({ region: 'us-east-1' });
            AWS.config.credentials = new AWS.Credentials({
                accessKeyId: credentials.accessKeyId,
                secretAccessKey: credentials.secretAccessKey,
                sessionToken: credentials.sessionToken
            });

            // The login API may respond with a plain DynamoDB result or an
            // API Gateway-style { statusCode, body } response.
            function readResponse(response){
                if(response && response.statusCode != null &&
                    (Number(response.statusCode) < 200 || Number(response.statusCode) >= 300)){
                    const error = new Error('Profile request failed');
                    error.statusCode = Number(response.statusCode);
                    throw error;
                }
                const body = response && response.body != null ? response.body : response;
                return typeof body == 'string' ? JSON.parse(body) : body;
            }

            // Retry only transient profile GET failures, not Cognito sign-in,
            // wallet creation or account mutations.
            function isTemporaryProfileError(error){
                if(!error || error.code === 'SESSION_EXPIRED') return false;

                const status = Number(
                    (error.response && error.response.status) ||
                    error.statusCode || error.status || 0
                );
                if(status === 408 || status === 429 || status >= 500) return true;
                if(status >= 400) return false;

                const code = String(error.code || error.name || '');
                if(/^(NetworkingError|NetworkError|TimeoutError|RequestTimeout|RequestTimeoutException|ThrottlingException|TooManyRequestsException|ServiceUnavailableException|ECONNABORTED|ETIMEDOUT|ERR_NETWORK|ERR_CONNECTION_RESET)$/i.test(code)){
                    return true;
                }

                const message = String(error.message || '');
                return /network error|failed to fetch|load failed|timed? ?out|connection (lost|reset)|network request failed/i.test(message) ||
                    error instanceof SyntaxError; // A truncated response can produce invalid JSON.
            }

            const profileUsername = String(currentUser || '').trim().toLowerCase();
            if(!profileUsername){
                const error = new Error('Authenticated username is unavailable');
                error.code = 'PROFILE_USERNAME_MISSING';
                throw error;
            }

            const maxProfileAttempts = 3;
            let profile = null;
            let profileFailure = 'missing-account';

            for(let attempt = 1; attempt <= maxProfileAttempts; attempt++){
                try {
                    const response = readResponse(await authenticatedPut('api1169ba1e', '', {
                        headers: { Authorization: `Bearer ${cognitoID}` },
                        body: {
                            category: 'db',
                            tableName: 'users',
                            primaryKey: profileUsername,
                            requestOperation: 'get'
                        }
                    }));

                    profile = response && response.Item;
                    if(profile && profile.username && String(profile.username).toLowerCase() !== profileUsername){
                        profile = null; // Wrong profile must never authenticate this username.
                    }
                    if(profile && /^0x[0-9a-fA-F]{40}$/.test(String(profile.publicKey || ''))){
                        profileFailure = null;
                        break;
                    }

                    // A successful HTTP response can still contain an empty Item.
                    // Give recently updated records a chance to become visible.
                    profileFailure = profile ? 'missing-wallet' : 'missing-account';
                } catch(profileError){
                    if(!isTemporaryProfileError(profileError)) throw profileError;
                    profileFailure = 'connection';
                }

                if(attempt < maxProfileAttempts){
                    // No account data, private keys, or tokens are logged.
                    console.warn('[TBP login] Retrying profile lookup', {
                        attempt,
                        reason: profileFailure
                    });
                    await new Promise(resolve => setTimeout(resolve, attempt * 700));
                }
            }

            if(profileFailure){
                console.warn('[TBP login] Profile lookup not ready', {
                    attempts: maxProfileAttempts,
                    reason: profileFailure
                });

                const messages = {
                    'connection': spanish ?
                        'La conexión se interrumpió al cargar tu cuenta. Revisa tu conexión a internet e inténtalo de nuevo.' :
                        'Your connection was interrupted while loading your account. Check your internet connection and try again.',
                    'missing-account': spanish ?
                        'Iniciaste sesión, pero no pudimos encontrar tu perfil. Inténtalo de nuevo o contacta a soporte.' :
                        'You signed in, but we could not find your account profile. Please try again or contact support.',
                    'missing-wallet': spanish ?
                        'Iniciaste sesión, pero no pudimos verificar la dirección de tu cartera. Inténtalo de nuevo o contacta a soporte.' :
                        'You signed in, but we could not verify your wallet address. Please try again or contact support.'
                };
                await clearInvalidSession();
                this.setState({
                    failedLoginBool: true,
                    errorTags: messages[profileFailure]
                });
                return;
            }

            let selectedLanguage = profile.preferences && profile.preferences.primaryLanguage ||
                this.state.selectedLanguage || 'english';

            try {
                const languageResponse = readResponse(await authenticatedPut('api1169ba1e', '', {
                    headers: { Authorization: `Bearer ${cognitoID}` },
                    body: {
                        category: 'db',
                        tableName: 'general',
                        primaryKey: 'languageSubscriberMap',
                        requestOperation: 'get'
                    }
                }));
                const languageMap = languageResponse && languageResponse.Item &&
                    languageResponse.Item.languageSubscriberMap;
                if(languageMap && languageMap[currentUser.toLowerCase()]){
                    selectedLanguage = languageMap[currentUser.toLowerCase()];
                }
            } catch(languageError){
                // A missing language preference must not block a valid login.
            }

            localStorage.setItem('mode_light_dark', profile.appearanceMode || 'dark');
            localStorage.setItem('primaryLanguage', selectedLanguage);

            this.setState({
                navigationDestinationObject: { navigationRoute: '/browser' },
                freezeButtonsBool: false,
                failedLoginBool: false,
                errorTags: null
            });
        } catch(err){
            if(authenticated) await clearInvalidSession();
            let message;
            if(!authenticated && (err.code == 'NotAuthorizedException' || err.code == 'UserNotFoundException')){
                message = spanish ? 'Usuario o contraseña incorrectos.' : 'Invalid username or password.';
            } else if(err.code == 'UserNotConfirmedException'){
                message = spanish ? 'Confirma tu correo antes de iniciar sesión.' : 'Confirm your email before signing in.';
            } else if(err.code == 'PasswordResetRequiredException'){
                message = spanish ? 'Restablece tu contraseña para iniciar sesión.' : 'Reset your password to sign in.';
            } else if(err.code === 'ACCOUNT_NOT_FOUND'){
                message = spanish ?
                    'Cuenta no encontrada. Completa el registro o contacta a soporte.' :
                    'Account Not Found. Please complete registration or contact support.';
            } else if(err.code == 'SESSION_EXPIRED'){
                message = spanish ? 'Tu sesión venció. Vuelve a iniciar sesión.' : 'Your session expired. Please sign in again.';
            } else {
                message = authenticated ?
                    (spanish ? 'Iniciaste sesión, pero no se pudo cargar tu cuenta. Inténtalo de nuevo.' :
                        'You signed in, but your account could not be loaded. Please try again.') :
                    (spanish ? 'No se pudo conectar para iniciar sesión. Inténtalo de nuevo.' :
                        'Could not connect to sign in. Please try again.');
            }
            this.setState({ failedLoginBool: true, errorTags: message });
        } finally {
            this.loginInProgress = false;
            this.setState({ freezeButtonsBool: false });
        }
    }

    render(){
        const { touched } = that.state;
        let className = touched ? 'button1_touched' : 'button1';
        
        if(navigationHandler(that.state.navigationDestinationObject)){
            return navigationHandler(that.state.navigationDestinationObject)
        }
      const renderProps = { API, AWS, Amplify, Auth, Button, ButtonContent, ButtonGroup, Component, Container, CryptoJS, Dropdown, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, Modal, Radio, React, Storage, awsconfig, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, className, cognitoID, corporateBackedUsernamesArray, currentUser, currentUserCap, isMobile, mode_light_dark, navigationHandler, posix, primaryDisplayCurrency, primaryLanguage, publicKey, region, routeProps, secondaryDisplayCurrency, secretName, that, tokenLifeTimeLimit, touched };

      if (isMobile) {
        return <WelcomeMobileRender {...renderProps} />;
      }

      return <WelcomeDesktopRender {...renderProps} />;
    }
}

export default Login;
